"use client";

import { useEffect } from "react";

// Opts a page into showing the Zoho SalesIQ launcher. The actual decision
// (and respecting Zoho's business-hours / offline hide rules) lives in the
// loader's `zsiqSetVisible` helper; here we just declare the page's intent and
// reset to hidden on unmount. `__zsiqVisQ` queues the intent in case this
// runs before the loader script has defined the helper.
const setVisible = (v) => {
  if (typeof window === "undefined") return;
  if (typeof window.zsiqSetVisible === "function") {
    window.zsiqSetVisible(v);
  } else {
    (window.__zsiqVisQ = window.__zsiqVisQ || []).push(v);
  }
};

export const ZohoSalesIQVisibility = ({ visible = false }) => {
  useEffect(() => {
    setVisible(visible);
    return () => setVisible(false);
  }, [visible]);

  return null;
};
